import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  h2: {
    margin: 0,
    paddingTop: '1rem',
    paddingBottom: '1rem',
    fontSize: '2rem',
    fontWeight: 300,
    lineHeight: 1.1,
    color: '#fff',
    textAlign: 'center',
  },
  block: {
    width: '100%',
    maxWidth: '25rem',
    margin: 0,
    marginBottom: 20,
    padding: '1rem 0',
    background: '#fff',
    boxShadow: '0 3px 15px -1px rgba(0,0,0,.5)',
    listStyle: 'none',
  },
  row: {
    display: 'flex',
    padding: '1rem 3rem',
    cursor: 'pointer',
    '&:hover': {
      background: '#eee',
    },
  },
  activeRow: {
    background: '#eee',
  },
  label: {
    fontSize: '1em',
    fontWeight: 400,
    lineHeight: 1,
    color: '#666',
  },
  buttonsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  button: {
    paddingLeft: 24,
    paddingRight: 24,
    fontSize: 15,
    color: '#fff',
    background: '#347AC4',
    '&:hover': {
      backgroundColor: theme.custom.mainColor,
      borderColor: theme.custom.mainColor,
      color: '#fff',
    },
    '&:focus': {
      outline: 0,
    },
    '&:first-child': {
      marginRight: 30,
    },
  },
}));
